:host {
  $wc-ticket-title-color-closed: var(--green, #3ebf4d);
  $wc-ticket-title-color-open: var(--orange, #ff8500);
  $wc-ticket-title-color-wait: var(--orange, #ff8500);

  .hide {
    display: none !important;
  }

  .tickets {
    width: 100%;
    height: 100%;
    background: transparent;
    color: #fff;
    border-radius: 8px 10px 10px 8px;
    padding: 0px 10px 30px;
    box-sizing: border-box;

    &.full {
      width: 600px;
      background: transparent;
      margin: auto;
    }

    &__subtitle {
      font-size: 20px;
      line-height: 28px;
      padding-left: 0px;
      padding-bottom: 24px;
      padding-top: 16px;
    }

    .ticket-list {
      margin-top: 16px;
      padding-bottom: 40px;

      .ticket-summary-container {
        display: flex;
        flex-direction: row;
        gap: 16px;
        width: 100%;
        font-size: 100%;
        font-family: inherit;
        background: #fff;
        padding: 24px 16px;
        border-radius: 8px;
        margin-bottom: 16px;
        transition: background ease 0.2s;

        &:hover {
          background: #f5f5f5;
        }

        .ticket-summary-action {
          display: flex;
          flex-shrink: 0;
          align-items: center;

          button {
            background: transparent;
            color: var(--blue, #0098ff);
            width: 100%;
            padding: 0;

            &__status {
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
            }
          }

          .closed {
            .title {
              &__round {
                background: $wc-ticket-title-color-closed;
              }
              &__status {
                color: $wc-ticket-title-color-closed;
              }
            }
          }

          .open {
            .title {
              &__round {
                background: $wc-ticket-title-color-open;
              }
              &__status {
                color: $wc-ticket-title-color-open;
              }
            }
          }

          .wait {
            .title {
              &__round {
                background: $wc-ticket-title-color-wait;
              }
              &__status {
                color: $wc-ticket-title-color-wait;
              }
            }
          }

          .description {
            color: #666;
            font-size: 16px;
            margin-right: 14px;
            line-height: 21px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .ticket-summary-action {
          display: flex;
          flex-shrink: 0;
          align-items: center;

          button {
            background: transparent;
            color: var(--blue, #0098ff);
            width: 100%;
            padding: 0;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
